import { z } from "zod";

// User Profile validation schema
export const userProfileSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  workEmail: z.string().email("Invalid email address"),
  jobTitle: z.string().max(255, "Job title must be 255 characters or less").nullable().optional().or(z.literal("")),
});

// Company Profile validation schema
export const companyProfileSchema = z.object({
  companyName: z.string().min(1, "Company name is required"),
  companyEmail: z.string().email("Invalid email address").nullable().optional().or(z.literal("")),
  websiteUrl: z.string().url("Invalid URL").nullable().optional().or(z.literal("")),
  addressLine1: z.string().nullable().optional().or(z.literal("")),
  addressLine2: z.string().nullable().optional().or(z.literal("")),
  city: z.string().nullable().optional().or(z.literal("")),
  state: z.string().nullable().optional().or(z.literal("")),
  country: z.string().min(1, "Country is required"),
  zipCode: z.string().nullable().optional().or(z.literal("")),
  isMailingAddressSame: z.boolean(),
  mailingAddressLine1: z.string().nullable().optional().or(z.literal("")),
  mailingAddressLine2: z.string().nullable().optional().or(z.literal("")),
  mailingState: z.string().nullable().optional().or(z.literal("")),
  mailingCountry: z.string().nullable().optional().or(z.literal("")),
  mailingZipCode: z.string().nullable().optional().or(z.literal("")),
});

// Trade Revenue validation schema
export const tradeRevenueSchema = z.object({
  asiRevenue: z.number().int().min(0).max(100000000).nullable().optional(),
  esiRevenue: z.number().int().min(0).max(100000000).nullable().optional(),
  psiRevenue: z.number().int().min(0).max(100000000).nullable().optional(),
  rsiRevenue: z.number().int().min(0).max(100000000).nullable().optional(),
});

// Type inference
export type UserProfileFormData = z.infer<typeof userProfileSchema>;
export type CompanyProfileFormData = z.infer<typeof companyProfileSchema>;
export type TradeRevenueFormData = z.infer<typeof tradeRevenueSchema>;
